import { relationships } from "@rocicorp/zero";
import { projectMember } from "./project-member";
import { user } from "./user";

export const projectMemberRelationships = relationships(projectMember, ({ one }) => ({
	_user: one({
		sourceField: ["userId"],
		destField: ["id"],
		destSchema: user,
	}),
}));
